module.exports = __webpack_public_path__ + "img/WeTool.293035d7.png";